{
  "common": {
    "show": "Vis",
    "about": "Om",
    "newPost": "Nyt indlæg",
    "active": "Aktiv",
    "change": "Skift",
    "remove": "Fjern",
    "cancel": "Annuller",
    "publish": "Udgiv",
    "save": "Gem",
    "draft": "Kladde",
    "scheduled": "Planlagt",
    "published": "Udgivet",
    "actions": "Handlinger",
    "archive": "Arkiv",
    "delete": "Slet",
    "edit": "Rediger",
    "edited": "Redigeret",
    "settings": "Indstillinger",
    "signUp": "Tilmeld dig",
    "by": "Af",
    "for": "for",
    "you": "Du",
    "one": "en",
    "option": "Valgmulighed ",
    "registered": "Tilmeldt",
    "to": "til",
    "allEvents": "Alle arrangementer",
    "placeholder": "pladsholder",
    "percentOf": "% af",
    "private": "Privat",
    "updatedOn": "Opdateret den",
    "blogPost": "Blogindlæg",
    "category": "Kategori",
    "author": "Forfatter",
    "status": "Status",
    "errors": {
      "label": "Fejl",
      "SOMETHING_WENT_WRONG": "Der opstod en fejl. Prøv igen senere."
    },
    "all": "Alle",
    "archived": " Arkiveret",
    "back": "Tilbage",
    "restore": "Gendan denne version",
    "next": "Næste",
    "previous": "Forrige",
    "continue": "Fortsæt",
    "continueButton": "Fortsæt",
    "paid": "Betalt",
    "free": "Gratis",
    "uploadImagesVideos": "Upload billeder/videoer",
    "upload": "Upload",
    "add": "Tilføj",
    "on": "Til",
    "from": "fra",
    "members": "medlemmer",
    "visibility": "Synlighed",
    "public": "Offentlig",
    "description": "Beskrivelse",
    "managedBy": "Administreret af",
    "noManagers": "Ingen ledere",
    "noDescription": "Ingen beskrivelse",
    "more": "mere",
    "moreCaps": "Mere",
    "less": "mindre",
    "and": "og",
    "in": "i",
    "allSet": "Så er du klar!",
    "createdBy": "Oprettet af",
    "home": "hjem",
    "selected": "Valgt",
    "groupMembers": "Gruppemedlemmer",
    "everyone": "Alle",
    "manager": "Manager",
    "leave": "Forlad",
    "membersList": "Medlemsliste",
    "findChannelManagers": "Find kanaladministratorer",
    "searchGroupMembers": "Søg efter gruppemedlemmer",
    "searchMembers": "Søg efter medlemmer",
    "searchMember": "Søg efter medlem",
    "enterDescription": "Indtast beskrivelse",
    "apply": "Anvend",
    "selectRole": "Vælg rolle",
    "people": "Mennesker",
    "viewProfile": "Vis profil",
    "leaderboard": "Rangliste",
    "events": "Begivenheder",
    "logOut": "Log ud",
    "topLevelReached": "Øverste niveau nået",
    "topLevelReachedExclaim": "Øverste niveau nået!",
    "congratsTopLevel": "Tillykke! Du har nået øverste niveau!",
    "share": "Del",
    "copyLink": "Kopiér link",
    "reply": "Svar",
    "download": "Download",
    "noPreviewAvailable": "Ingen tilgængelig forhåndsvisning",
    "userNotFound": "Bruger ikke fundet",
    "userNotFoundMessage": "Der blev ikke fundet en bruger",
    "thisGroupIsPrivate": "Denne gruppe er privat",
    "unableToPreviewPdf": "Det er i øjeblikket ikke muligt at få vist PDF-filen. Download den for at se den.",
    "failedToDownloadPdf": "Kunne ikke downloade PDF-filen",
    "notifyAll": "Giv besked til alle i kanalen",
    "communities": "Fællesskaber",
    "courses": "Kurser",
    "affiliates": "Tilknyttede enheder",
    "chats": "snak",
    "switchToDarkMode": "Skift til mørk tilstand",
    "switchToLightMode": "Skift til lys tilstand",
    "editProfile": "Rediger profil",
    "account": "Konto",
    "logout": "Log ud",
    "noResults": "Ingen resultater",
    "confirmPayment": "Bekræft betaling",
    "done": "Færdig",
    "manage": "ADMINISTRER",
    "copied": "Kopieret",
    "submit": "Indsend",
    "request": "Forespørgsel",
    "approve": "Godkend",
    "decline": "Afvis",
    "comingSoon": "Kommer snart",
    "detailsUpdatedSuccessfully": "Oplysningerne blev opdateret",
    "oopsUnableToSaveDetails": "Ups! Det er ikke muligt at gemme oplysningerne.",
    "verificationFailedPleaseTryAgain": "Bekræftelse mislykkedes. Prøv igen",
    "loading": "Indlæser",
    "title": "Titel",
    "addLink": "Tilføj link",
    "writeHere": "Skriv her",
    "copy": "Kopiér",
    "reset": "Nulstil",
    "register": "Tilmeld dig",
    "search": "Søg",
    "confirm": "Bekræft",
    "success": "Gennemført",
    "toReview": "Til Anmeldelse",
    "invite": "Inviter",
    "contributions": "Bidrag",
    "communitiesSettings": "Indstillinger for fællesskaber",
    "create": "Opret",
    "name": "Navn",
    "linkCopied": "Link Kopieret!",
    "move": "Flyt",
    "irreversible": "uigenkaldelig",
    "close": "Luk",
    "greeting": "Hej {name}!",
    "managePayments": "Administrer betalinger",
    "manageYourAccount": "Administrer din konto",
    "accountSettings": "Konto Indstillinger",
    "proceed": "Fortsæt",
    "uploading": "Uploader",
    "retry": "Prøv igen",
    "login": "Log ind",
    "follow": "Følg",
    "following": "Følger",
    "followers": "Følgere",
    "view": "VIS",
    "selectAnOption": "Vælg en mulighed",
    "channels": "Kanaler",
    "somethingWentWrong": "Noget gik galt. Prøv igen",
    "switchToNormalMode": "Skift til normal tilstand",
    "switchToReadingMode": "Skift til læsetilstand",
    "goToHomepage": "Gå til hjemmesiden",
    "onlyGroupOwnersCanCreateCourses": "Kun gruppeejere kan oprette nye kurser",
    "createGroup": "Opret gruppe",
    "discover": "Discover",
    "continuePayment": "Fortsæt betaling",
    "invalidCredentials": "Du har indtastet en ugyldig e-mail eller et password. Prøv igen.",
    "comingUpEvents": "Kommende begivenheder!",
    "integratePaymentGateway": "Integrer betalingsgateway",
    "connectPaymentGateway": "Tilslut en ny betalingsgateway, eller administrer dine eksisterende.",
    "isLive": "er live",
    "justNow": "Lige nu",
    "likes": "Synes godt om",
    "accessRequired": "Adgang*",
    "zeroProgress": "0",
    "noFollowersTitle": "Det ser ud til, at ingen følger dig.",
    "noFollowersSubtext": "Tilføj din forbindelse til følgelisten",
    "noFollowingTitle": "Du følger ikke nogen endnu.",
    "noFollowingSubtext": "Gå i gang med at følge personer for at se deres opslag",
    "followBack": "Følge tilbage",
    "logIn": "LOG IND",
    "video": "Video",
    "audio": "Lyd",
    "newVersionAvailable": "En ny version af appen er tilgængelig. Opdater for at kunne bruge denne funktion!",
    "ariaLabels": {
      "backButton": "Tilbage-knap",
      "openEventLocation": "Åbn begivenhedsplacering",
      "editEvent": "Rediger begivenhed",
      "deleteEvent": "Slet begivenhed",
      "cancelRsvp": "Annuller S.U.",
      "publicGroupRadio": "Radioknap for offentlig gruppe",
      "privateGroupRadio": "Radioknap for privat gruppe",
      "accessibleFromSwitcherCheckbox": "Tilgængelig fra afkrydsningsfeltet for omskifteren",
      "allowMembersToInviteCheckbox": "Afkrydsningsfelt for at tillade medlemmer at invitere",
      "addMembers": "Tilføj medlemmer",
      "settings": "Indstillinger",
      "leaveChannel": "Forlad kanalen",
      "channelSettings": "Kanalindstillinger",
      "selectRole": "Vælg rolle",
      "deleteChannel": "Slet kanal",
      "changeToPrivateChannel": "Skift til privat kanal",
      "allowMembersToPosts": "Tillad medlemmerne at slå op",
      "restrictMembersFromPosts": "Begræns medlemmers mulighed for at sende indlæg",
      "close": "Luk",
      "open": "Åbn",
      "more": "Mere",
      "upload": "Upload",
      "play": "Afspil",
      "pause": "Sæt på pause",
      "mute": "Slå lyden fra",
      "unmute": "Slå lyden til",
      "fullscreen": "Fuld skærm",
      "exitFullscreen": "Afslut fuld skærm",
      "download": "Download",
      "share": "Del",
      "like": "Synes godt om",
      "comment": "Kommentar",
      "reply": "Svar",
      "pin": "Fastgør",
      "unpin": "Frigør",
      "report": "Anmeld",
      "copyLink": "Kopiér link",
      "embedCode": "Indlejringskode",
      "previewImage": "Forhåndsvis billede",
      "profileImage": "Profilbillede",
      "coverImage": "Coverbillede",
      "thumbnail": "Miniaturebillede",
      "attachment": "Vedhæftet fil",
      "removeAttachment": "Fjern vedhæftning",
      "uploadFile": "Upload fil",
      "selectFile": "Vælg fil",
      "searchIcon": "Søgeikon",
      "menuIcon": "Menuikon",
      "notification": "Notifikation",
      "messages": "Beskeder",
      "profile": "Profil",
      "logout": "Log ud",
      "send": "Send",
      "cancel": "Annuller",
      "submit": "Indsend",
      "next": "Næste",
      "previous": "Forrige",
      "refresh": "Opdater",
      "filter": "Filtrer",
      "sort": "Sortér",
      "view": "Vis",
      "expand": "Udvid",
      "collapse": "Fold sammen",
      "downloadFile": "Download fil",
      "closeModal": "Luk modalvindue",
      "addMedia": "Tilføj medier",
      "lightModeRadio": "Radioknap til lys tilstand",
      "darkModeRadio": "Radioknap til mørk tilstand",
      "communityThemeRadio": "Radioknap til fællesskabstema",
      "userProfile": "Brugerprofil",
      "postActions": "Slå op-handlinger",
      "chatWindow": "Chat-vindue",
      "chatActions": "Chat-aktiviteter",
      "minimizeChat": "Minimer chatten",
      "closeChat": "Luk chatten",
      "commentActions": "Kommentarhandlinger",
      "replyToComment": "Svar på kommentar",
      "groupLogo": "Gruppelogo",
      "pinGroupIcon": "Fastgør gruppe-ikon",
      "appSwitcher": "App-omskifter",
      "communities": "Fællesskaber",
      "courses": "Kurser",
      "search": "Søg",
      "giphyLogo": "Giphy-logo",
      "backToConversations": "Tilbage til samtaler",
      "commentAttachments": "Kommentarvedhæftninger",
      "tabSwitcher": "Fanebladsomskifter",
      "eventCover": "Begivenhedscover",
      "eventCoverPreview": "Forhåndsvisning af begivenhedscover",
      "selectPaidEvent": "Vælg betalt begivenhed",
      "selectFreeEvent": "Vælg gratis begivenhed",
      "selectCurrency": "Vælg valuta",
      "logo": "Logo",
      "closeReviewMembershipAnswersModal": "Luk modal for gennemgang af medlemskabssvar",
      "liveStream": "Livestream",
      "openGroupMembers": "Åben gruppe-medlemmer",
      "communityBanner": "Fællesskabsbanner",
      "home": "Hjem",
      "mentionItem": "Omtaleobjekt",
      "back": "Tilbage",
      "viewGroup": "Vis gruppe",
      "invitationIcon": "Invitationsikon",
      "openUserProfile": "Åben bruger-profil",
      "closeStream": "Luk stream",
      "groupAvatar": "Gruppeavatar",
      "bannerImage": "Bannerbillede",
      "avatarImage": "Avatarbillede",
      "userAvatar": "Brugeravatar",
      "eventImage": "Begivenhedsbillede",
      "postImage": "Slå billede op",
      "channelIcon": "Kanalikon",
      "groupIcon": "Gruppeikon",
      "communityIcon": "Fællesskabsikon",
      "memberAvatar": "Medlems-avatar",
      "creatorAvatar": "Skaber-avatar",
      "authorAvatar": "Forfatter-avatar",
      "aboutFeaturedPost": "Om det fremhævede indlæg",
      "accountSettings": "Kontoindstillinger",
      "addChannel": "Tilføj Kanal",
      "addCourse": "Tilføj kursus",
      "addEmoji": "Tilføj emoji",
      "affiliates": "Tilknyttede enheder",
      "announceEvents": "Annoncebegivenheder",
      "avatar": "Avatar",
      "badge": "Badge",
      "camera": "Kamera",
      "cardImage": "Oversigtsbillede",
      "categoryName": "Kategorinavn",
      "channelList": "Kanalliste",
      "channelSelect": "Vælg kanal",
      "chatAttachment": "Chatvedhæftning",
      "chats": "Chats",
      "closeCourseDetails": "Luk kursusoplysningerne",
      "closeLoginModal": "Luk log ind-modal",
      "closeMembershipQuestionsModal": "Luk modal for medlemskabsspørgsmål",
      "closePaymentModal": "Luk udbetalingsmodal",
      "commentCard": "Kommentaroversigt",
      "communityTheme": "Fællesskabstema",
      "conversationItem": "Samtaleemne",
      "conversationSuggestion": "Samtaleforslag",
      "createChannel": "Opret kanal",
      "customThemeRadio": "Tilpasset radioknap for tema",
      "deleteAnswerButton": "Slet svar-knap",
      "deleteFile": "Slet fil",
      "editLevelName": "Rediger niveaunavn",
      "editProfile": "Rediger profil",
      "enterEmailAddress": "Indtast e-mailadresse",
      "featuredIcon": "Fremhævet ikon",
      "giveAdministrativePrivileges": "Giv administrative rettigheder",
      "gokollabLogo": "GoKollab-logo",
      "icon": "Ikon",
      "image": "Billede",
      "likeContent": "Synes godt om-indhold",
      "link": "Forbind",
      "marketplaceGroupSlug": "Marketplace-gruppeslug",
      "microphone": "Mikrofon",
      "nextAttachment": "Næste vedhæftede fil",
      "noEvents": "Ingen begivenheder",
      "noCommunitiesIllustration": "Ingen fælleskabsillustrationer",
      "noCoursesFound": "Ingen kurser blev fundet",
      "noFollowers": "Ingen følgere",
      "noFollowing": "Ingen følger",
      "noPostsFound": "Der blev ikke fundet nogen indlæg",
      "notificationItem": "Notifikationsobjekt",
      "notificationsList": "Notifikationsliste",
      "openEmbeds": "Åben indlejringer",
      "openEmbedsDrawer": "Åbn indlejringsskuffen",
      "openEventColor": "Åbne begivenhedsfarve",
      "openEventDetails": "Oplysninger om åben begivenhed",
      "permissionNeeded": "Godkendelse nødvendig",
      "pointsAndLevels": "Point og niveauer",
      "previousAttachment": "Tidligere vedhæftede fil",
      "reactedUser": "Reagerende bruger",
      "reward": "Belønning",
      "rewards": "Belønninger",
      "selectChannel": "Vælg kanal",
      "selectEventOption": "Vælg begivenhedsmulighed",
      "selectIcon": "Vælg ikon",
      "selectTimezone": "Vælg tidszone",
      "showChannelIcons": "Vise kanal-ikoner",
      "sidebarActionButton": "Sidebjælke-handlingsknap",
      "speaker": "Højttaler",
      "text": "Tekst",
      "thisGroupIsPrivate": "Denne gruppe er privat",
      "toReview": "Til gennemgang",
      "toggleFeaturedPost": "Skift fremhævet indlæg",
      "toggleRewardsOptions": "Skift belønningsvalgmuligheder",
      "viewReplies": "Vis svar",
      "courseThumbnail": "kursus-miniaturebillede",
      "moreManagers": "flere ledere",
      "arrowIcon": "→",
      "okHandEmoji": "👌",
      "closeIcon": "✕",
      "changeToPublicChannel": "Skift til offentlig kanal",
      "showMandatoryInfoModal": "Vis obligatorisk profilmodalt afkrydsningsfelt"
    },
    "placeholders": {
      "groupName": "Gruppenavn",
      "groupSlug": "Gruppe-slug",
      "url": "URL",
      "enterPrice": "Indtast pris",
      "enterName": "Indtast navn",
      "enterEmail": "Indtast e-mail",
      "selectTimezone": "Vælg tidszone",
      "selectChannel": "Vælg kanal",
      "enterSkoolGroupUrl": "Indtast dit Skooles fællesskabs-URL"
    },
    "email": "E-mail",
    "errorLoadingConversations": "Fejl ved indlæsning af samtaler",
    "noConversations": "Ingen samtaler"
  },
  "imageUpload": {
    "cropYourAvatar": "Beskær din avatar",
    "dragToReposition": "Træk for at flytte",
    "ariaLabels": {
      "imageUploader": "Billeduploader",
      "avatar": "Avatar",
      "clearFile": "Fjern fil",
      "removeAvatar": "Fjern profilens avatar",
      "zoomButton": "Zoom-knap"
    }
  },
  "mediaUpload": {
    "uploadVideo": "Upload video",
    "addVideoUsingLink": "Tilføj video ved hjælp af link",
    "uploadImage": "Upload billede",
    "addVideo": "Tilføj video"
  },
  "mandatedInfoModal": {
    "completeYourProfile": "Færdiggør din profil",
    "profileIntentMessage1": "Fællesskaber føles underlige uden ansigter og navne.",
    "profileIntentMessage2": "Profiler skaber tillid og skaber forbindelse til andre",
    "complete": "FULDFØRT",
    "recommendedAspectRatio": "Upload en {types}. Anbefalet Udseende Procentdel 1:1",
    "addBio": "Tilføj en biografi ... (valgfrit)"
  },
  "validations": {
    "nameRequired": "Navn er påkrævet.",
    "invalidDescription": "Ugyldig beskrivelse."
  },
  "payment": {
    "recurringWithTrial": "Du vil blive opkrævet {currencySymbol}{price} pr. {interval}, efter prøveperioden er slut, med mulighed for at annullere når som helst.",
    "recurring": "{currencySymbol}{price} pr. {interval} med mulighed for at annullere til enhver tid.",
    "oneTime": "{currencySymbol}{price} {paymentText}",
    "defaultOneTimeText": "Engangspris for medlemskab.",
    "totalAmount": "Beløb i alt",
    "viewBreakdown": "Vis opdeling",
    "hideBreakdown": "Skjul opdeling",
    "subtotal": "Delsum",
    "salesTax": "Moms",
    "taxesMayApply": "Skatter kan pålægges ved betaling",
    "inclTax": "Inkl. moms",
    "totalDueToday": "Total forfalden i dag",
    "trialDays": "{days} dages prøveversion",
    "securePayments": "100 % sikre betalinger",
    "allowToChargeCard": "Ved at give dine kortoplysninger giver du {locationName} mulighed for at debitere kortet til fremtidige betalinger i overensstemmelse med deres vilkår.",
    "address": {
      "country": "Land",
      "state": "Stat",
      "zipCode": "Postnummer",
      "city": "By",
      "addressLine1": "Adresselinje 1",
      "addressLine2": "Adresselinje 2 (valgfri)",
      "streetAndNumber": "Gade/vej og nummer",
      "apartmentAndUnit": "Lejlighed, suite, enhed, bygning, etage osv.",
      "selectCountry": "Vælg land",
      "selectState": "Vælg stat",
      "calculatingTaxes": "Beregning af skatter",
      "continueToPayment": "Fortsæt til betaling",
      "validationError": "Udfyld alle de påkrævede adressefelter.",
      "taxInfo": "Vi bruger kun din adresse til at beregne gældende skatter."
    },
    "paymentSuccessful": "Betaling lykkedes.",
    "errors": {
      "FDS_DECLINED": "Din transaktion er blevet afvist. Kontakt virksomhedsejeren."
    }
  },
  "channel": {
    "notifications": {
      "managersEdited": "Lederne blev redigeret.",
      "managersAdded": "Lederne blev tilføjet.",
      "managersAddedToChannel": "ledere blev tilføjet til",
      "membersAdded": "Medlemmer blev tilføjet!",
      "memberPostingEnabled": {
        "title": "Opdateret Medlemmer-opslag",
        "content": "Medlemmers opslag har været Aktiveret"
      },
      "roleUpdated": "Rollen blev opdateret!",
      "updatedRoleOf": "Opdateret rolle for {name}",
      "userRemoved": "Brugeren blev slettet!",
      "removedUserFrom": "Slettet {name} fra {channelName}",
      "errorOccurred": "Der opstod en fejl",
      "CHANNEL_MEMBER_ROLE_UPDATE_NOT_FOUND": "Kan ikke opdatere rollen, fordi dette medlem ikke blev fundet.",
      "CHANNEL_MEMBER_ROLE_UPDATE_OWNER_FORBIDDEN": "Denne handling er ikke tilladt for gruppeejeren.",
      "CHANNEL_MEMBER_REMOVE_USER_NOT_FOUND": "Kan ikke fjerne brugeren, fordi dette medlem ikke kunne findes.",
      "CHANNEL_MEMBER_REMOVE_CHANNEL_NOT_FOUND": "Kan ikke fjerne brugeren, fordi denne kanal ikke kunne findes.",
      "CHANNEL_MEMBER_REMOVE_OWNER_FORBIDDEN": "Gruppeejeren kan ikke fjernes fra kanalen.",
      "CHANNEL_MEMBER_REMOVE_USER_NOT_IN_CHANNEL": "Denne bruger er ikke en del af den valgte kanal.",
      "updated": {
        "title": "Opdaterede kanalindstillinger",
        "contentPrivate": "Kanalen {channelName} er nu privat",
        "contentPublic": "Kanalen {channelName} er nu offentlig",
        "content": ""
      },
      "deleted": {
        "title": "Kanalen blev slettet",
        "content": ""
      },
      "membersAddedSuccess": {
        "title": "Medlemmerne blev tilføjet!",
        "content": "{count} medlemmer blev tilføjet til {channelName}"
      },
      "managersAddedSuccess": {
        "title": "Lederne blev tilføjet.",
        "content": "{count} ledere tilføjet til {channelName}"
      },
      "memberPostingDisabled": {
        "title": "Opdateret Medlemmer-opslag",
        "content": "Medlemmers opslag er blevet deaktiveret"
      },
      "visibilityChangedToPublic": "Kanalen {channelName} er nu offentlig",
      "visibilityChangedToPrivate": "Kanalen {channelName} er nu privat",
      "created": {
        "title": "Ny kanal blev oprettet",
        "content": ""
      },
      "error": {
        "createFailed": {
          "title": "Kanalen kunne ikke oprettes",
          "content": "Prøv igen senere"
        },
        "updateFailed": {
          "title": "Kanalen kunne ikke opdateres",
          "content": "Prøv igen senere"
        },
        "managersEditedFailed": {
          "title": "Opdatering af ledere mislykkedes.",
          "content": ""
        },
        "addFailed": {
          "title": "Tilføjelse af ledere mislykkedes.",
          "content": ""
        },
        "addMembersFailed": {
          "title": "Tilføjelse af medlemmer mislykkedes!",
          "content": ""
        }
      }
    },
    "createChannel": "Opret kanal",
    "updateChannel": "OPDATER KANALEN",
    "addMembers": "Tilføj medlemmer",
    "addManagers": "Tilføj ledere",
    "typeToAddMoreMembers": "Indtast for at tilføje flere medlemmer",
    "examplePlaceholder": "eks. John eller Jane",
    "makeChannelManager": "Opret kanalmanager",
    "removeFromChannelManager": "Fjern fra kanalmanager",
    "manager": "Manager",
    "channelManager": "Kanalmanager",
    "noMembersFound": "Der blev ikke fundet nogen medlemmer.",
    "noManagersFound": "Der blev ikke fundet nogen ledere.",
    "removeChannelMember": "Fjern kanalmedlem",
    "removeConfirmationMessage": "Er du sikker på, at du vil fjerne",
    "makeManagerConfirmationMessage": "Er du sikker på, at du vil gøre",
    "makeManagerConfirmationMessage2": "til kanalmanager i",
    "channelName": "Kanalnavn",
    "channelIcon": "Kanalikon",
    "addChannel": "Tilføj Kanal",
    "editChannel": "Rediger kanal",
    "announcementChannel": "MEDDELELSE Kanal",
    "noChannelsAvailable": "Ingen tilgængelige kanaler",
    "makeChannelPrivate": "Gør kanalen privat",
    "makeChannelPrivateMessage": "Begræns medlemmets adgang til alle kanaldiskussioner og interaktioner.",
    "readOnlyChannel": "Kun læse-kanal",
    "readOnlyChannelMessage": "Medlemmer kan se vigtige informationer og opdateringer, men kun kanalens administratorer/ejere kan skrive opslag her.",
    "createPrivateChannel": "Gør denne kanal privat",
    "createPrivateChannelMessage": "Kun for inviterede medlemmer. Ikke-medlemmer vil ikke kunne se denne kanal",
    "allowMembersToPost": "Aktive Medlemmer til Dele",
    "allowMembersToPostMessage": "Aktivering af denne mulighed Aktivere Medlemmer for at Opret indlæg og feedback",
    "enableMemberPostingConfirmation": {
      "mainMessage": "Hvis du aktiverer medlemmer-opslag, vil Aktivere hver Medlemmer to opret og slette indlæg i kanalen.",
      "mainMessage2": "Sørg for, at hver medlem er opmærksom på de ny udsendelse af Tilladelser.",
      "pointer1": "Denne håndtering kan fortrydes til en hvilken som helst Dato.",
      "pointer2": "hvert indlæg Oprettet af Medlemmer vil være synlig for Alle in kanalen."
    },
    "privateChannelTooltip": "Du har ikke adgang til denne kanal",
    "restrictMembersFromPosting": "Begræns Medlemmer Fra-opslag",
    "restrictMembersFromPostingMessage": "Deaktiver denne mulighed vil forhindre Medlemmer Fra Oprettet Eller i at redigere indlæg og feedback i kanalen.",
    "disableMemberPostingConfirmation": {
      "mainMessage": "Deaktiver Medlemmer-opslag vil begrænse hvert Medlemmer Fra Oprettet og deling af indlæg i kanalen.",
      "mainMessage2": "Sørg for, at hver medlem er opmærksom på de nye opslagsbegrænsninger.",
      "pointer1": "Denne håndtering kan fortrydes til en hvilken som helst Dato.",
      "pointer2": "hvert indlæg Oprettet af Medlemmer Før denne Rediger vil forblive synlig for Alle in kanalen."
    },
    "deleteChannel": "Slet kanal",
    "deleteChannelMessage": "Hvis kanalen slettes, mistes alle de tilknyttede data permanent.",
    "deleteChannelMessageWithCourse": "Hvis kanalen slettes, mistes permanent hver Medlemmer-data, og eventuelle kurser, der er knyttet til denne kanal, bliver Offentlig, medmindre du sletter dem først.",
    "editChannelName": "Rediger kanalnavn",
    "editChannelDescription": "Rediger kanalbeskrivelse",
    "channelNamePlaceholder": "f.eks. markedsføringsrapporter",
    "editManagers": "Rediger managere",
    "channelManagers": "Kanalmanagere",
    "leaveChannel": "Forlad kanalen",
    "leaveChannelConfirmation": "Er du sikker på, at du vil forlade denne kanal?",
    "changeToPrivateChannel": "Gør kanalen privat",
    "changeToPrivateChannelMessage": "Hvis du gør kanalen privat, begrænses brugen af kanalen til interaktioner og diskussioner til dens medlemmer.",
    "changeToPrivateChannelConfirmation": {
      "mainMessage": "Hvis du skifter denne kanal til Privat, vil SLOTMAX få adgang til kun til Valgt Medlemmer og ledere.",
      "mainMessage2": "Husk at inkludere hvert ønsket Medlemmer til din private kanal.",
      "pointer1": "Denne håndtering er",
      "pointer2": "ny Medlemmer tilføjet til kanalen vil få adgang til hver Forrige diskussioner og interaktioner i kanalen."
    },
    "changeToPublicChannel": "Gør kanalen offentlig",
    "changeToPublicChannelMessage": "At gøre Kanalen Offentlig vil aktivere alle Gruppe Medlemmer til at vise og deltage in denne Kanal.",
    "changeToPublicChannelConfirmation": {
      "mainMessage": "At skifte denne kanal til offentlig vil gøre den offentlig for alle fællesskabets medlemmer.",
      "mainMessage2": "Alle gruppemedlemmer vil kunne se og deltage i denne kanal.",
      "pointer1": "Alle gruppemedlemmer vil automatisk få adgang til denne kanal.",
      "pointer2": "TIDLIGERE Privat Kanal Medier vil blive synligt for Alle Gruppe Medlemmer."
    },
    "publicChannel": "Offentlig kanal",
    "peopleWhoCanManage": "Mennesker, der kan administrere",
    "addChannelHelperText": "Vis mere fællesskab: Tilføj kanaler til forskellige diskussioner, Duet og tilslutning.",
    "privateChannel": "Privat kanal",
    "removeFromChannel": "Slet fra kanalen",
    "removeConfirmationMessage2": "fra denne kanal",
    "findChannelManagers": "Find kanaladministratorer",
    "removeChannelManager": "Fjern kanaladministrator",
    "irreversible": "Denne handling er uigenkaldelig"
  },
  "chat": {
    "unblockUser": "Fjern blokering af bruger",
    "blockUser": "Bloker bruger",
    "blockMessage1": "Du vil ikke længere kunne sende beskeder til denne bruger.",
    "blockMessage2": "Denne konto blokeres ikke i gruppen. You kan muligvis stadig se vedkommendes opslag, kommentarer og reaktioner.",
    "deleteChat": "Slet chat",
    "deleteChatMessage": "Er du sikker på, at du vil slette denne samtale?",
    "block": "Bloker",
    "conversation": "samtale",
    "youPrefix": "Du: ",
    "messageNotSent": "Denne besked blev ikke sendt",
    "sending": "Sender",
    "youAndUserKnowEachOther": "Du og {name} kender hinanden",
    "startConversationWithHi": "Start en samtale ved at sende \"Hej\"",
    "accountSettings": "Kontoindstillinger",
    "blockedUserMessage": "Du har blokeret { name }. Du kan ikke sende eller modtage beskeder. Fjern blokeringen af vedkommende for at starte en samtale. Hvis du vil gennemgå din liste over blokerede brugere, kan du se dine",
    "blockRecipientMessage": "{ name } har blokeret dig. Du kan ikke sende eller modtage beskeder.",
    "nothingFound": "Det blev ikke fundet noget.",
    "pleaseCheckUsername": "Kontrollér brugernavnet, og prøv igen",
    "startChatting": "Begynd at chatte",
    "noChatYet": "Det ser ud til, at du ikke har chattet med nogen endnu.",
    "noChatYetMessage": "Søge efter en kontakt og tag det første trin!",
    "noConversationsFound": "Der blev ikke fundet nogen samtaler",
    "searchMembersAndStartChatting": "Søg medlemmer, og begynd at chatte",
    "cannotMessageDeletedUser": "Du kan ikke Upload beskeder til en Slettet Bruger",
    "message": "Besked",
    "media": "Medier",
    "files": "Filer"
  },
  "comments": {
    "reportComment": "Anmeld kommentar",
    "reportCommentMessage": "Er du sikker på, at du vil anmelde denne kommentar?",
    "deleteComment": "Slet kommentar",
    "editComment": "Rediger kommentar",
    "loadMoreReplies": "Indlæs flere svar",
    "deleteCommentMessage": "Er du sikker på, at du vil slette denne kommentar?",
    "writeComment": "Skriv en kommentar",
    "comment": "KOMMENTAR",
    "cancel": "ANNULLER",
    "save": "GEM",
    "replyingTo": "Svarer på",
    "newComment": "ny kommentar",
    "latest": "Seneste",
    "onlyAdminsCanComment": "Kun fællesskabsadministratorer kan kommentere in denne kanal.",
    "isCommentDisabledForPost": "Feedback er Deaktiveret for dette Dele.",
    "isCommentDisabledErrorContent": "Feedback er blevet Deaktiveret på dette Dele Via Editor Eller Gruppe Administrator.",
    "isCommentDisabledErrorTitle": "feedback Deaktiveret",
    "notifications": {
      "saveComment": "Fejl ved lagring af kommentaren",
      "error": "Der opstod en fejl. Prøv igen senere.",
      "COMMENT_CONTENT_SIZE_EXCEEDED": "Kommentarindholdet er for stort. Reducer størrelsen, og prøv igen.",
      "COMMENTS_DISABLED": "Kommentarer er blevet deaktiveret på dette opslag af forfatteren eller gruppe-admin."
    }
  },
  "embeds": {
    "uploadImage": "Upload billede",
    "addYoutubeVimeoLoomLink": "Tilføj et YouTube-, Vimeo- eller Loom-link",
    "uploadAttachment": "Upload PDF-, CSV- eller XLSX-filer",
    "addAttachment": "Tilføj vedhæftet fil",
    "allowedTypes": "SVG, PNG, JPG eller GIF (maks. 800x400 px)",
    "placeholder": "Tilføj et YouTube-, Vimeo- eller Loom-link",
    "uploadVideo": "Upload/link video",
    "uploadVideoPlaceholder": "Tilføj et YouTube-, Vimeo- eller Loom-link",
    "uploadVideoAllowedTypes": "Upload en MP4-videofil",
    "addEmoji": "Tilføj emoji",
    "emojiSuggestion": "Åbner emoji-vælger",
    "addGif": "Tilføj GIF",
    "gifSuggestion": "Åbner GIF-vælger",
    "addImage": "Tilføj billede",
    "imageSuggestion": "Åbner dit galleri",
    "addVideo": "Tilføj video",
    "videoSuggestion": "Åbner dit galleri",
    "selectFile": "Vælg fil",
    "attachmentSuggestion": "Åbner filhåndtering",
    "takePhoto": "Tag billede",
    "uploadPhotoVideo": "Upload foto/video",
    "limitExceeded": "Grænse overskredet",
    "limitExceededMessage": "Du kan ikke vedhæfte mere end 4 filer",
    "errorWhileUploadingFile": "Fejl under upload af fil. Prøv igen",
    "notifications": {
      "uploadError": "Fejl ved upload af fil",
      "FILE_SIZE_EXCEEDED": "Filstørrelsen overstiger den maksimale uploadgrænse på 50 MB.",
      "VIDEO_SIZE_EXCEEDED": "Videostørrelsen overstiger den maksimale uploadgrænse på 1 GB."
    },
    "clickToUpload": "Klik for at uploade,",
    "orDragAndDrop": "eller træk og slip",
    "validUrl": "Gyldig URL er påkrævet",
    "enterSomeText": "Indtast tekst",
    "addLink": "Tilføj link",
    "text": "Tekst",
    "addVideoLink": "Eller, Inkludere a YouTube, Vimeo, Loom, Eller Wistia - Video .",
    "uploadVideoAndImages": "Upload videoer og billeder",
    "recommendedAspectRatio": "Anbefalet Udseende Procentdel {ratio}",
    "addHashtag": "Etiket kanaler, tilfælde og kurser",
    "hashtagSuggestion": "Hashtagforslag"
  },
  "tabSwitcher": {
    "discussion": "Opslag",
    "learning": "Læring",
    "members": "Medlemmer",
    "people": "Folk",
    "leaderboard": "Rangliste",
    "channels": "Kanaler",
    "groups": "Grupper",
    "more": "Mere",
    "home": "Start",
    "discover": "Opdag",
    "courses": "Kurser",
    "communities": "Fællesskaber"
  },
  "groupInfo": {
    "pinGroup": "Fastgør Gruppe",
    "unpinGroup": "Frigør Gruppe",
    "maxPinnedGroupsLimit": "Kun op til 4 Gruppe kan fastgøres",
    "publicGroup": "Offentlig gruppe",
    "privateGroup": "Privat gruppe",
    "coverImage": "Gruppecover",
    "members": "Medlemmer",
    "posts": "Indlæg",
    "admin": "Administrator",
    "settings": "INDSTILLINGER",
    "inviteMembers": "INVITER MEDLEMMER",
    "answerQuestions": "Svar på spørgsmål",
    "toJoin": "for at være med {name} ",
    "leaveGroup": "Forlad gruppen",
    "leaveGroupConfirmMessage": "Er du sikker på, at du vil forlade denne gruppe? Du mister din adgang til alle betalte kurser og betalte begivenheder samt dit gruppemedlemskab.",
    "leaveGroupSuccessTitle": "Du har forladt gruppen",
    "leaveGroupSuccessMessage": "Du har forladt gruppen.",
    "leaveGroupErrorTitle": "Kan ikke forlade gruppen",
    "leaveGroupErrorMessage": "Der opstod en fejl under udtrædelsen af gruppen. Prøv igen.",
    "groupActions": "Gruppehandlinger",
    "changeRole": "Rediger rolle",
    "removeFromGroup": "Fjern fra gruppen",
    "contributor": "Bidragsyder",
    "membershipAnswers": "Medlemskabssvar",
    "unbanMember": "Fjern udelukkelse af medlem",
    "banFromGroup": "Udeluk fra gruppe",
    "requestedOn": "Anmodet den",
    "invitedOn": "Inviteret den",
    "joinedOn": "Blev medlem",
    "noMembersFound": "Ingen medlemmer fundet.",
    "youAreAllCaughtUp": "Du're hver indhentet — ingen Medlemmer her Højre nu!",
    "banUserConfirmation": "Er du sikker på, at du vil udelukke denne bruger fra gruppen?",
    "deleteContentCheckbox": "Slet hver Indhold Oprettet af denne Bruger",
    "active": "Aktiv",
    "admins": "Administratorer",
    "contributors": "Bidragydere",
    "requested": "Anmodet",
    "banned": "Udelukket",
    "invited": "Inviteret",
    "paymentReceived": "Betaling modtaget",
    "paymentInitiated": "Udbetaling igangsat",
    "answeredQuestions": "Besvarede spørgsmål",
    "answeredQuestionsMessage": "besvarede det følgende spørgsmål for at deltage",
    "darkMode": "Mørk tilstand",
    "darkModeMessage": "Juster udseendet af fællesskabet for at reducere genskin og give dine øjne en pause.",
    "accessGranted": "Log ind: Påbegynd dit læringseventyr.",
    "stepIntoAction": "Så er det i gang! Lad os samarbejde og have det sjovt.",
    "viewMembersAndMemberDetails": "Vis medlemmer og medlemsoplysninger",
    "reviewContentReportsAndMore": "Gennemgå indholdsrapporter og mere",
    "toReview": "Til gennemgang",
    "switchToOtherGroups": "Skift til anden gruppe",
    "placeholders": {
      "yourAnswer": "Dit svar"
    },
    "notifications": {
      "userBanned": "Brugeren er blevet udelukket fra gruppen",
      "somethingWentWrong": "Der opstod en fejl. Prøv igen senere."
    },
    "membershipSettings": "Indstillinger for medlemskab",
    "paymentFailed": "Betaling mislykkedes.",
    "paymentFailedMessage": "Betaling mislykkedes. Din anmodning om at deltage i gruppen er blevet afvist.",
    "gamification": {
      "addRewards": "Tilføj belønninger",
      "title": "Titel",
      "description": "Tilføj beskrivelse",
      "textbox": "Tekstboks",
      "singleSelect": "Vælg individuel",
      "multipleSelect": "Vælg flere",
      "question": "Spørgsmål",
      "validations": {
        "titleRequired": "Angiv titel",
        "descriptionRequired": "Angiv beskrivelse",
        "somethingWentWrong": "Der opstod en fejl. Prøv igen senere.",
        "updatedRewards": "Opdaterede belønninger"
      },
      "settings": {
        "updatedRewards": "Opdaterede belønninger"
      }
    },
    "customCode": {
      "advanced": "Avanceret",
      "testPreview": "Testforhåndsvisning",
      "enableConfirmationMessage": "Aktivér det kun, når du bekræfter testeksemplet",
      "testPreviewMessage": "Dette åbner en ny fane med testforhåndsvisningen af dit fællesskab. Du kan bruge dette til at kontrollere, om din brugerdefinerede kode fungerer som forventet.",
      "liveMode": "Live",
      "customJS": "Tilpasset JS",
      "customCSS": "Tilpasset CSS",
      "trackingCode": "Trackingkode",
      "headerCode": "Kode",
      "footerCode": "Sidefod Kode"
    },
    "branding": {
      "brandYourGroup": "Du kan brande din gruppe efter dit valg her",
      "updateBranding": "Opdater branding",
      "clickToUploadFavicon": "Klik for at uploade Favicon",
      "dragAndDropFavicon": "Træk og slip: {types} (formatforhold 1:1)",
      "clickToUploadCover": "Klik for at uploade cover",
      "dragAndDropCover": "Træk og slip: {types} (formatforhold 16:9)",
      "clickToUploadLogo": "Klik for at uploade gruppelogo",
      "dragAndDropLogo": "Træk og slip: {types} (formatforhold 1:1)",
      "aspectRatioMustBe1To1": "Billedets billedformat skal være 1:1",
      "aspectRatioMustBe16To9": "Billedets billedformat skal være 16:9",
      "favicon": "Favicon",
      "coverImage": "Coverbillede",
      "logo": "Logo",
      "invalidFileFormat": "Ups! Ugyldig filformat/filtype.",
      "pleaseUploadImageType": "Understøttede filtyper: {types}"
    },
    "groupAppearance": {
      "description": "Du kan konfigurere din gruppes udseende efter eget valg her",
      "slug": "Opdater dit gruppeudseende her",
      "colorMode": "Farve",
      "previewTheLook": "Få vist en forhåndsvisning af, hvordan din gruppe vil se ud i lys og mørk tilstand",
      "light": "Lys",
      "dark": "Mørk",
      "communityTheme": "Fællesskabstema",
      "customTheme": "Brugerdefineret tema",
      "windowGradient": "Vindue Gradient",
      "applyGradientColorsToYourSidebarAndTopbar": "Anvend Gradient -farver til din sidebjælke og topbjælke",
      "labels": {
        "sidebarBackground": "Baggrund for sidebjælke",
        "primary": "PRIMÆR",
        "secondary": "Sekundær",
        "tertiary": "Tertiær",
        "surface": "Overflade",
        "fontPrimary": "PRIMÆR Skrifttype",
        "fontSecondary": "Sekundær skrifttype",
        "fill": "Fylde Farve",
        "border": "Kant",
        "error": "Fejl",
        "background": "Baggrund",
        "option": "Valgmulighed"
      },
      "customThemes": {
        "default": "Standard",
        "zestyCitrus": "Sjov citrus",
        "royalVelvet": "Royal fløjl",
        "sunnyDelight": "Sunny Delight",
        "lushMeadow": "Frodig eng",
        "azureDreams": "Azure drømme",
        "bubblegumBliss": "Bubblegum Bliss",
        "ivoryWhisper": "Ivory Whisper",
        "midnightDeep": "Midnatsdyb"
      },
      "unsavedChanges": "Ikke-gemt Dynamisk",
      "unsavedChangesMessage": "Du har ikke gemt Tema Dynamisk, er du sikker på, at du vil Fortryd the Dynamisk?"
    },
    "promotionalLinks": {
      "promotionalLinks": "Salgsfremmende links",
      "createPromotionalLinkDescription": "Opret reklamelinks til din gruppe",
      "addPromotionalLink": "Tilføj link",
      "deleteLink": "Slet link",
      "deleteLinkConfirmation": "Er du sikker på, at du vil slette dette link?",
      "labels": {
        "description": "Beskrivelse",
        "url": "URL",
        "private": "Privat",
        "privateLinksDescription": "Private links er kun synlige for gruppemedlemmer"
      },
      "placeholders": {
        "enterLinkDescription": "Indtast beskrivelse af linket",
        "enterLinkURL": "Indtast link URL"
      },
      "addPromotionalLinkDescription": "Opret reklamelinks til din gruppe",
      "ariaLabels": {
        "editLink": "Rediger link",
        "deleteLink": "Slet link"
      }
    },
    "membershipQuestions": {
      "addQuestion": "Tilføj spørgsmål",
      "editQuestion": "Rediger spørgsmål",
      "editLevelName": "Rediger niveaunavn",
      "addOption": "Tilføj mulighed",
      "level": "Niveau",
      "name": "Navn",
      "addMembersQuestionsDescription": "Tilføj spørgsmål til medlemmerne, når de beder om adgang til din gruppe",
      "enableMembershipQuestions": "Aktivér spørgsmål om medlemskab",
      "membershipQuestions": "Spørgsmål om medlemskab",
      "deleteQuestion": "Slet spørgsmål",
      "deleteQuestionConfirmation": "Er du sikker på, at du vil slette dette spørgsmål?",
      "labels": {
        "textBox": "Tekstboks",
        "singleSelect": "Vælg individuel",
        "multipleSelect": "Vælg flere",
        "enableMembershipQuestions": "Tilføj mindst ét ​​spørgsmål for at aktivere spørgsmål om medlemskab"
      },
      "validations": {
        "questionRequired": "Indtast spørgsmål",
        "answerOptionsRequired": "Min. to valgmuligheder er påkrævet, og de skal være unikke",
        "somethingWentWrong": "Der opstod en fejl. Prøv igen senere.",
        "updatedQuestions": "Opdaterede spørgsmål om gruppemedlemskab",
        "levelNameRequired": "Indtast niveaunavn",
        "updatedLevelName": "Opdateret niveaunavn"
      },
      "placeholders": {
        "enterLevelName": "Niveaunavn",
        "selectOne": "Vælg en",
        "keepItShort": "hold det kort ...",
        "exampleOffer": "f.eks 10 % Deaktiveret til første køb"
      },
      "privacyNotice": "Jeg forstår, at mine svar vil være Arkiv og synlige for Gruppe-administratorer.",
      "ariaLabels": {
        "editQuestion": "Rediger spørgsmål",
        "deleteQuestion": "Slet spørgsmål"
      }
    },
    "gamificationAndRewards": {
      "title": "Tilpas niveauer og belønninger",
      "description": "Tilpas niveaunavne, og tilføj belønninger for bedre engagement af medlemmer",
      "gamification": "Gamification",
      "rewards": "Belønninger",
      "addRewards": "Tilføj belønning",
      "ariaLabels": {
        "toggleGamification": "Slå gamification-indstillinger til/fra"
      }
    },
    "invitations": {
      "invitationSentSuccessfully": "Invitationen blev sendt",
      "invitationSentSuccessfullyDescription": "Invitationen blev sendt til {email}",
      "shareGroupLink": "Del dit gruppelink",
      "inviteMember": "Inviter medlem",
      "inviteMemberDescription": "Opbyg dit fællesskab ved at invitere et nyt medlem",
      "inviteViaEmail": "Inviter via e-mail",
      "invitedMembersWillBeAutoApproved": "Inviterede medlemmer bliver automatisk godkendt til at deltage i gruppen",
      "sendInvite": "SEND INVITATION",
      "permissionDenied": "Du har ikke Godkendelse til at invitere Medlemmer. Kontakt din administrator.",
      "notifications": {
        "INVITATION_CREATE_UNAUTHORIZED": "Du har ikke tilladelse til at sende invitationer.",
        "INVITATION_CREATE_GROUP_DISALLOWS_INVITE": "Denne gruppe tillader ikke medlemmerne at invitere andre.",
        "INVITATION_CREATE_ALREADY_INVITED": "Denne bruger er allerede blevet inviteret.",
        "INVITATION_CREATE_ALREADY_MEMBER": "Denne bruger er allerede medlem af gruppen."
      },
      "labels": {
        "giveAdministrativePrivileges": "Giv administrative rettigheder",
        "giveAdministrativePrivilegesDescription": "Tillad dette medlem at udføre alle administrative handlinger",
        "name": "Navn",
        "email": "E-mail",
        "nameLabel": "Navn",
        "emailLabel": "E-mail"
      },
      "placeholders": {
        "enterName": "Indtast navn",
        "enterEmail": "Indtast e-mail"
      }
    },
    "groupDetails": {
      "updateGroupDetails": "Opdater gruppeoplysninger",
      "updateGroupDetailsDescription": "Opdater dine gruppeoplysninger her",
      "slugNotAvailable": "Gruppe-slug er ikke tilgængelig",
      "description": "Uddyb arten af diskussioner, der vil finde sted i gruppen",
      "publicDescription": "Alle kan se gruppeindlæggene og andre medlemmer af gruppen",
      "privateDescription": "Kun medlemmer kan se gruppeindlæggene og andre medlemmer af gruppen",
      "accessibleFromSwitcher": "Tilgængelig fra offentlig",
      "accessibleFromSwitcherDescription": "Din gruppe vil være synlig for ikke-gruppemedlemmer i omskifteren",
      "allowMembersToInvite": "Tillad medlemmer at invitere nye medlemmer",
      "allowMembersToInviteDescription": "Skjuler invitationsknappen for medlemmer, når den er slået fra.Medlemmer kan kun invitere andre, hvis dette er aktiveret.",
      "showMandatoryInfoModal": "Vis obligatorisk profilmodal",
      "showMandatoryInfoModalDescription": "Når det er aktiveret, vil medlemmer blive bedt om at udfylde deres profiloplysninger, når de tilmelder sig gruppen.",
      "slug": "Gruppe-slug",
      "discovery": {
        "title": "Opdagelse",
        "description": "Bliv opdaget af millioner af aktive brugere.Gruppen vil være synlig på opdagelsessiden, når du har mere end 10 medlemmer.",
        "discoverChannels": "Opdage kanaler",
        "joinGroupToExploreAllChannels": "Deltag i gruppen for at udforske hver kanalerne",
        "categoryIsUsedOnlyOnGokollab": "Kategorien bruges kun på Gokollab",
        "categoryAutomaticallySuggested": "Kategorien foreslås automatisk ved hjælp af AI baseret på din gruppes overskrift og beskrivelse. For at få det mest præcise forslag skal du sørge for, at dine gruppeoplysninger tydeligt afspejler dens formål og emner.",
        "categoryRefreshLimited": "Kategoriopdatering er begrænset til én gang hver 24. time"
      },
      "placeholders": {
        "description": "Indtast en kort beskrivelse"
      },
      "validations": {
        "nameRequired": "Indtast et gyldigt gruppenavn.",
        "slugRequired": "Indtast en gyldig gruppe-slug.",
        "specialCharacterNotSupported": "Specialtegn understøttes ikke",
        "descriptionRequired": "Gruppebeskrivelse er påkrævet.",
        "emailRequired": "Indtast en gyldig e-mail.",
        "fullNameRequired": "Indtast et gyldigt navn."
      },
      "labels": {
        "groupName": "Gruppe"
      }
    },
    "subscriptions": {
      "manageSubscriptions": "Administrer dine abonnementer",
      "viewAndManageGroupSubscriptions": "Se og administrer gruppeabonnementer",
      "paymentIntegrationMissingMessage": "Integrer betalinger in Placering til Aktivere Betalt Gruppe",
      "price": "Pris",
      "currency": "Valuta",
      "priceDisplay": "{symbol}{price}{suffix}",
      "priceInterval": "/{interval}",
      "oneTime": " En Dato",
      "priceDeletedAlert": "Betalingsprodukt er Fra Synkronisering, klik på hende for at synkronisere igen",
      "intervals": {
        "month": "Måned",
        "year": "År",
        "week": "Uge",
        "day": "Dag"
      },
      "addNewPrice": "Tilføj ny Pris",
      "editPrice": "Rediger Pris",
      "addPrice": "Tilføj Pris",
      "subscriptionType": {
        "recurring": "Tilbagevendende",
        "oneTime": "En Dato"
      },
      "billingPeriod": {
        "monthly": "Månedlig",
        "annually": "Årligt",
        "weekly": "Ugentlig",
        "daily": "Daglig"
      },
      "ariaLabels": {
        "freeMembership": "Radioknap til gratis medlemskab",
        "paidMembership": "Radioknap til betalt medlemskab"
      }
    },
    "menuOptions": {
      "details": "Oplysninger",
      "subscriptions": "Abonnementer",
      "branding": "Branding",
      "themes": "Tema",
      "tabsConfiguration": "Vis/skjul faner",
      "membershipQuestions": "Spørgsmål om Medlemskab",
      "gamificationAndRewards": "Gamification og belønninger",
      "links": "Links",
      "newsletter": "Nyhedsbrev",
      "reportedContent": "Rapporteret Indhold",
      "discovery": "Opdagelse",
      "import": "Importere"
    },
    "newsletter": {
      "title": "Nyhedsbrev",
      "subheading": "Dit fællesskabsoversigt",
      "frequency": "Nyhedsbrevets frekvens",
      "description": "En oversigt over populære indlæg, medlemsaktivitet og begivenheder fra denne gruppe",
      "time": "Tidspunkt",
      "weekday": "Ugedag",
      "monthDay": "Månedsdag",
      "lastDay": "Seneste dag",
      "selectFrequency": "Klik Frekvens",
      "frequencies": {
        "off": "Fra",
        "daily": "Daglig",
        "weekly": "Ugentlig",
        "biweekly": "Hver anden uge",
        "monthly": "Månedligt"
      }
    },
    "tabConfiguration": {
      "title": "Vis/skjul faner",
      "description": "Styr hvilke faner der vises i dit fællesskab. Aktivér eller deaktiver hver fane for at skabe en fokuseret og strømlinet oplevelse for dine medlemmer.",
      "discussionDescription": "Start eller deltag i samtaler for at dele opdateringer, idéer og indsigt med dit fællesskab.",
      "learningDescription": "Opret og administrer kurser, der hjælper medlemmerne med at tilegne sig nye færdigheder eller viden.",
      "eventsDescription": "Planlæg, organiser og se kommende sessioner, workshops eller fællesskabsarrangementer.",
      "leaderboardDescription": "Anerkend de bedst præsterende medlemmer, og tilskynd til sundt engagement gennem ranglister.",
      "membersDescription": "Administrer alle medlemmer og roller. Denne fane vil forblive synlig for administratorer, selv når den er deaktiveret, så medlemsadministration altid er tilgængelig.",
      "aboutDescription": "Introducer jeres fællesskabs formål, værdier og baggrund for at hjælpe medlemmerne med at skabe forbindelse.",
      "discussionTooltip": "Diskussion er en kernefane i fællesskabet og kan ikke deaktiveres",
      "aboutTooltip": "Fanen 'Om' er påkrævet for at give essentielle oplysninger om fællesskabet og kan ikke deaktiveres."
    },
    "groupSettings": {
      "groupSettings": "Gruppe Indstillinger",
      "changeGroupType": "Rediger Gruppe Skrive",
      "changeGroupTypeDescriptionPrivateToPublic": "Dynamisk til en Offentlig Gruppe betyder, at hver Afventer Forespørgsler automatisk bliver Accepteret, og Indhold bliver offentligt synlig. Fortsæt?",
      "changeGroupTypeDescriptionPublicToPrivate": "Dynamisk til en privat Gruppe betyder, at nye Medlemmer har brug for Godkendelse og Indhold forbliver Skjult, indtil de er Accepteret. Fortsæt?",
      "changeGroupTypeConfirmation": "Er du sikker på, at du vil Rediger Gruppe Skrive?",
      "changeGroupTheme": "Rediger Gruppe Tema",
      "changeGroupThemeDescription": "Dette vil Rediger temaet for hver Gruppe Medlemmer. Er du sikker på, at du vil Rediger Gruppe Tema?",
      "updatedGroupDetails": "Opdateret Gruppe Oplysninger",
      "unableToSaveDetails": "Ups! Kan ikke Arkiv Oplysninger.",
      "groupNameIsRequired": "Gruppen Navn er Påkrævet",
      "groupDescriptionIsRequired": "Gruppe Beskrivelse er Påkrævet",
      "groupSlugIsRequired": "Gruppe Slug er Påkrævet",
      "groupSlugMustContainOnly": "Gruppe Slug må kun indeholde Små bogstaver bogstaver, Mængde og bindestreger",
      "groupSlugAlreadyExists": "Gruppe Slug findes allerede. Brug en anden Slug , da denne allerede er taget",
      "groupSlugRestricted": "Dennes slug matcher med et af vores private nøgleord til fællesskab-links. Brug en anden slug",
      "pleaseTryAgainLater": "Prøv igen senere",
      "unsavedChangesMessage": "Du har Gruppe Slug Dynamisk, der ikke er gemt, er du sikker på, at du vil fortryde dem?"
    },
    "import": {
      "header": "Importer Skolegruppemedlemmer og deres indhold",
      "credentialDescription": "Indtast dine Skool-loginoplysninger for at importere dine gruppemedlemmer og deres indhold",
      "csvUploadDescription": "Vælg .csv Fil to Importere kontakter Fra Skool",
      "loginFailed": "Du har indtastet en Ugyldig e-mail Eller password. Prøv igen.",
      "proceedWithImport": "Fortsæt med Importere?",
      "iAgree": "Jeg er enig",
      "importTerms": "Via at klikke på \"Jeg accepterer\" bekræfter og anerkender Du, at Du har engageret os som en uafhængig Aftale til at udføre Serviceydelser Til dine vegne (\"Serviceydelser\"). The Serviceydelser Inkludere the Overfør af visse data, Oplysninger, Indhold, intellektuelle Egenskaber Eller any Andet Indhold (\"Info\") Fra a Udstedte Platform Konto to a Modtaget Platform Konto. Du erklærer og garanterer, at (i) Du er de retmæssige Ejer af Info in Udstedte-platformen Konto, (ii) du har Tilladelser til at give os Få adgang til til Udstedte Platform Konto for Hensigten af udførelse af Serviceydelser, og ( iii) Overførslen af Info vil ikke krænke tredjeparts intellektuelle Egenskaber Tilladelser Eller overtræde tredjeparts kontrakter. Du accepterer at holde, forsvare og På holde os skadesløs for tredjepartskrav, der opstår som et resultat af dit brud på ovenstående repræsentanter og garantier.",
      "pleaseDownloadCSV": "Download .CSV-fil",
      "step01": "Trin 01-",
      "step02": "Trin 02-",
      "uploadCSV": "Upload .CSV",
      "step01Description": "Fylde in Eller opdatere eventuelle manglende Oplysninger for Gruppe Medlemmer såsom Gmail, fornavn osv. Sørg for, at CSV er uploadet in",
      "thisTemplate": "denne Skabelon",
      "importCSV": "Importere .CSV",
      "reSyncData": "Re-Synkronisering af dine data Før Download.",
      "refreshUserList": "Opdater Bruger-listen",
      "reSyncDataDescription": "Hvis ny Bruger er tilføjet in mellemtiden, anbefaler vi, at du opdaterer din liste og Download CSV.",
      "pleaseDontChangeProfileSlug": "Undlad at Rediger Profil Slug.",
      "selectFile": "Vælge Fil",
      "changeFile": "Rediger Fil",
      "importMembersFailedText": "Dette kan skyldes, at de mangler e-mailadresse. Fløj dine Importere Fil og Prøv igen med gyldig e-mailadresse til disse medlemmer.",
      "upload": "Upload",
      "tryAgain": "Prøv igen",
      "importerAnotherGroup": "Start New Import",
      "syncAllPosts": "Synkronisering hver din Slet og kommentar",
      "membersCouldNotBeAdded": "Medlemmer kunne ikke føjes til gruppen.",
      "importMembersSuccess": "Vi har sendt en e-mail til hver Individuel Gruppe Medlemmer, der bekræfter deres Medlemskab in Gruppen og giver dem Få adgang til Oplysninger. Dette er med til at sikre, at hvert medlem er informeret og effektivt kan få adgang til gruppen.",
      "importMembersAdded": "Medlemmer er blevet tilføjet til gruppen",
      "postsNotSynced": "Resterende indlæg kunne ikke synkronisering til gruppen. Dette kan skyldes, at Dele Forfattere ikke blev importeret.",
      "migrationFailed": "Migrering mislykkedes. Prøv igen.",
      "migrationCompleted": "Migration Færdig!",
      "migrationInProgress": "Migrering i gang",
      "createProfile": "Opret profil",
      "enterCredentials": "Indtast legitimationsoplysninger",
      "uploadingInProgress": "Upload in gang!",
      "listMembers": "Liste af Medlemmer bliver",
      "downloaded": "Download",
      "uploaded": "uploadet",
      "listPostsDownloaded": "Listen over indlæg er Download.",
      "listPostsDownloading": "Listen over indlæg Download.",
      "posts": "indlæg",
      "members": "Medlemmer",
      "imported": "importeret",
      "step1": "Trin 1",
      "step2": "Trin 2",
      "step1Description": "Opret en medlemsprofil i Skool Group.",
      "step1Description2": "(inklusive navn, e-mail Id og adgangskode)",
      "step2Description": "Indtast Skool-medlemsoplysninger",
      "skoolUrlPlaceholder": "Indtast din Skools gruppe-URL",
      "emailPlaceholder": "Indtast din Skools e-mail-ID",
      "emailTooltip": "Indtast e-mailen Medlemmer med din Skool Konto",
      "passwordPlaceholder": "Indtast din skoles adgangskode",
      "confirm": "Bekræft",
      "validation": {
        "skoolUrl": "Indtast en gyldig Skool-URL",
        "email": "E-mail er Påkrævet",
        "password": "Adgangskode er Påkrævet"
      }
    },
    "approved": "Accepteret",
    "pending": "Afventer",
    "rejected": "Afvist"
  },
  "invitations": {
    "intent": "Hjælp dette fællesskab med at vokse!",
    "cancelInvitation": "Annuller invitation",
    "inviteMembers": "Inviter medlemmer til at samarbejde om dette fællesskab.",
    "inviteLink": "Invitationslink",
    "invitationLink": "invitationslink",
    "buildYourCommunity": "Opbyg dit fællesskab!",
    "inviteMembersToCollaborate": "Du har oprettet et nyt fællesskab! Inviter medlemmer til at samarbejde om dette fællesskab.",
    "invite": "Inviter",
    "basicInformation": "Grundlæggende oplysninger",
    "permissions": "Tilladelser"
  },
  "createPost": {
    "title": "Opret nyt blogindlæg",
    "placeholder": "Hvad tænker du på",
    "liveStream": "Livestream",
    "slug": "URL-slug til blogindlæg",
    "titleHelp": "Titlen, beskrivelsen og billedet vil blive brugt til SEO-metatag",
    "nameLabel": "Titel på blogindlæg",
    "nameValidation": "Titlen er påkrævet",
    "descriptionLabel": "Beskrivelse af indlæg",
    "descriptionHelp": "Giv en kort beskrivelse, så seerne kan få et glimt af indlægget. Fungerer bedst mellem 100-250 tegn",
    "descriptionValidation": "Beskrivelse er påkrævet",
    "createLabel": "Opret indlæg",
    "image": "Billede i blogindlæg",
    "imageDescription": "Den anbefalede størrelse er 600 px * 400 px",
    "notificationTitle": "Blogindlæg oprettet",
    "notificationErrorTitle": "Kunne ikke oprette blogindlæg",
    "postingIn": "in",
    "editingIn": "Redigering in"
  },
  "post": {
    "downloadRecording": "Download optagelse",
    "deletePost": "Slet indlæg",
    "reportPost": "Rapportér indlæg",
    "editPost": "Rediger indlæg",
    "createPost": "Opret indlæg",
    "publish": "Indlæg",
    "publishPost": "Udgiv indlæg",
    "addChannel": "Tilføj Kanal",
    "selectChannel": "Vælg kanal",
    "addLink": "Tilføj link",
    "removeLink": "Fjern link",
    "update": "Opdater",
    "unsavedChanges": "Du har Skift, der ikke er gemt",
    "unsavedChangesMessage": "De Skift, der ikke er gemt, vil gå tabt. Vil du stadig fortsætte?",
    "unpinFromChannel": "Frigør",
    "unpinFromHome": "Frigør",
    "deletePostConfirmation": "Er du sikker på, at du vil slette dette opslag?",
    "reportPostConfirmation": "Er du sikker på, at du vil rapportere dette opslag?",
    "postNotFound": "Indlægget blev ikke fundet",
    "postNotFoundMessage": "Det indlæg, du forsøger at se, er enten slettet eller findes ikke.",
    "loadMoreComments": "Indlæs flere kommentarer",
    "channelNotFound": "Kanalen blev ikke fundet",
    "isCurrentlyLive": "er i øjeblikket live",
    "isStartingNow": "begynder nu",
    "isHappeningInMinutes": "sker om {minutes} minutter",
    "isHappeningInHours": "sker in {hours} tid | sker in {hours} tid",
    "publicChannel": "Offentlig kanal",
    "privateChannel": "Privat kanal",
    "featured": "Fremhævet",
    "featuredAbout": "Om Udvalgt",
    "noPostsFound": "Der blev ikke fundet nogen indlæg",
    "pinInfo": "Du kan fastgøre elementer, der skal vises øverst i gruppen, herunder indlæg, regler og hashtags.",
    "pinInfoEveryone": "Alle i gruppen vil se disse elementer.",
    "pinInfoRemainVisible": "Fastgjorte elementer forbliver synlige, indtil du fjerner fastgørelsen af dem.",
    "pinInfoNewestItem": "Når du fastgør elementer, vises det nyeste element forrest på listen.",
    "onlyVisibleToAdmins": "Kun synlig for administratorer",
    "featuredAboutDescription": "Dine administratorer har fastgjort disse elementer, så gruppen kan se dem.",
    "channelNotFoundMessage": "Du er ikke længere medlem af den kanal, du forsøger at få adgang til, eller kanalen er blevet slettet.",
    "notifications": {
      "unpinned": "Frigjort!",
      "pinned": "Fastgjort!",
      "reported": "Indlægget er blevet rapporteret.",
      "error": "Der opstod en fejl.",
      "isCommentDisabled": "Feedback Deaktiveret!",
      "isCommentEnabled": "Feedback aktiveret!",
      "createPost": "Fejl ved oprettelse af indlæg",
      "editPost": "Fejl ved redigering af indlæg",
      "POST_CONTENT_SIZE_EXCEEDED": "Indlæggets indhold er for stort. Reducer størrelsen, og prøv igen."
    },
    "movePostToChannel": "Flyt til kanal",
    "pin": "Fastgør",
    "pinToHome": "Fastgør til startside",
    "pinToChannel": "Fastgør til kanal",
    "whatIsYourTitle": "Hvad er din titel?",
    "postMovedToChannel": "Slet blev flyttet til {channelName} kanal",
    "upcomingEvent": "Kommende begivenhed",
    "turnOffCommenting": "Deaktiver kommentarer",
    "enableComments": "Aktivér kommentarer",
    "disableComments": "Deaktiver feedback",
    "moveToPrivateChannelConfirmation": {
      "title": "Flyt til privat kanal",
      "message": "Du er ved at flytte dette opslag til en privat kanal. Kun medlemmer af den private kanal vil kunne se den. Vil du fortsætte?"
    },
    "onlyAdminsCanPost": "Kun fællesskabsadministratorer kan dele i denne Kanal."
  },
  "reaction": {
    "noLikes": "Ingen synes godt om",
    "andOthers": "og {count} andre"
  },
  "UIConfirmation": {
    "privateGroup": "Denne gruppe er privat",
    "privateGroupMessage": "Du skal være medlem af denne gruppe for at få adgang til gruppespecifikke oplysninger. Anmod om adgang ved at klikke på knappen Deltag i gruppe."
  },
  "notifications": {
    "noNotificationsYet": "Ingen notifikationer endnu",
    "whenYouGetNotifications": "Når du får notifikationer, vises de her",
    "markAllAsRead": "Markér alle som læst",
    "notifications": "Notifikationer",
    "all": "Alle",
    "unread": "Ulæst",
    "checkNotifications": "Log ind for at tjekke notifikationer",
    "noNotifications": "Ingen notifikationer!",
    "redirectedFromOldSlug": {
      "title": "Du er blevet omdirigeret til det opdaterede link til fællesskabet",
      "content": "Dette er gjort for at forbedre SEO-ydeevnen for dette fællesskab. Opdater venligst Deres bogmærker med denne nye URL."
    }
  },
  "joinGroupModal": {
    "wahoo": "Wuhuu! 🎉 anmodningen er sendt",
    "reviewRequestSoon": "Vores gruppeadministratorer vil snart gennemgå din anmodning. Vær tålmodig – vi giver dig besked, når dit medlemskab er godkendt.",
    "nonMemberMessage": "Du skal være en del af denne gruppe for at kunne synes godt om og kommentere indlæg",
    "subscribeFor": "Abonner på",
    "joinGroup": "DELTAG I GRUPPEN",
    "membershipPending": "Medlemskab PENDING",
    "viewMembershipAnswers": "Vis svar på Medlemskab",
    "requested": "Anmodet",
    "dayFreeTrial": "dags gratis prøveperiode",
    "notPartOfGroup": "Du er ikke en del af denne Gruppe endnu, dit Medlemskab Forespørgsler er in Anmeldelse. Når en Administrator Accepteret din Forespørgsler vil vi underrette Du",
    "pleaseAnswerMembershipQuestions": "Svar på Medlemskab-spørgsmålene for at deltage i denne gruppe",
    "answerQuestions": "Svar på medlemskabsspørgsmål"
  },
  "userProfilePopover": {
    "active": "Aktiv",
    "longAgo": "længe siden",
    "chatDisabled": "Denne bruger har deaktiveret sin chat",
    "pointsToLevelUp": "point for at stige i niveau",
    "profile": "Profil",
    "deletedUser": "Slettet bruger",
    "joined": "Blev medlem af",
    "contributions": "Bidrag"
  },
  "courses": {
    "by": "Af",
    "free": "Gratis",
    "unknownInstructor": "Ukendt instruktør",
    "courseRestricted": "Denne Rute er Privat",
    "courseDeleted": "Dette kursus er blevet slettet",
    "noMatchingCourseFound": "Der blev ikke fundet noget matchende kursus",
    "addCourse": "Tilføj kursus",
    "updateCourse": "Opdater kursus",
    "access": "Alle medlemmer har adgang",
    "unableToAddCourse": "Ups! Kurset kunne ikke tilføjes",
    "pleaseTryAgainLater": "Prøv igen senere",
    "paymentIntegrationMissing": "Ups! Betalingsintegration mangler",
    "paymentIntegrationMissingMessage": "Integrer betalinger på stedet for at aktivere betalte kurser",
    "course": "Kursus",
    "courseInThisGroup": "een bestaande cursus in deze groep",
    "courseLinkCopied": "Kursuslink blev kopieret.",
    "buyNow": "KØB NU",
    "locked": "LÅST",
    "buyCourse": "KØB KURSUS",
    "open": "ÅBEN",
    "moveCard": "Flyt kort",
    "courseViewMessage": "Du skal være en del af denne gruppe for at se kurserne.",
    "deleteCourse": "Slet kursus",
    "deleteCourseConfirmation": "Er du sikker på, at du vil slette dette kursus?",
    "courseAccessNotGranted": "Kursusadgang er ikke tildelt",
    "courseAccessNotGrantedMessage": "Vi arbejder i øjeblikket på at give dig adgang til kurset. Opdater siden, og prøv igen om et minut.",
    "autoRenewsAfter": "Fornyes automatisk efter",
    "oneTimePayment": "Engangsbetaling",
    "emptyCoursesMessage": "Det ligner en spøgelsesby. Der er ikke noget at se her",
    "updatedSuccessfully": "Kursus Opdateret blev gennemført",
    "addedSuccessfully": "Kurset blev tilføjet",
    "createCourse": "Opret nyt kursus",
    "emptyCourseLibrary": "Dit rutebibliotek er tomt!",
    "createdOutsideGokollabMessage": "Dette fællesskab blev oprettet uden for Gokollab & gjort synligt. For at Generere nye Kurser, bedes De logge in på fællesskab fra dets Kilde Kanal.",
    "createCourseOnGokollabMessage": "Generere en ny rute Til Gokollab for at Opret det tilgængeligt for dine fællesskab Medlemmer.",
    "or": "eller",
    "createNewOne": "Generere en ny",
    "labels": {
      "selectCourse": "Vælg kursus",
      "courseVisibility": "Kursets synlighed",
      "courseAccess": "Kursusadgang",
      "coursePrice": "Kursuspris",
      "subscriptionType": "Abonnementstype",
      "billingPeriod": "Faktureringsperiode",
      "testMode": "Testtilstand",
      "turnOnTestPayments": "Slå testbetalinger til med et testkort",
      "currency": "Valuta",
      "trialDays": "Dage i prøveversion",
      "recurring": "Tilbagevendende",
      "free": "Gratis",
      "oneTime": "En Dato",
      "refresh": "Opdater",
      "accessStartsAtDay": "Få adgang til starter fra Dag",
      "maximumYouCanEnterIs365": "Maks. Du kan indtaste er 365",
      "allMembers": "Alle medlemmer",
      "levelUnlock": "Niveaulås op",
      "buyNow": "Køb nu",
      "timeUnlock": "Tidslås",
      "gamificationLevel": "Gamification Flad",
      "privateChannel": "Privat kanal",
      "private": "Privat",
      "marketingChannel": "Markedsføring",
      "selectCurrency": "Vælg valuta"
    },
    "placeholders": {
      "enterPrice": "Indtast pris",
      "enterTrialDays": "Indtast dage i prøveversion",
      "selectCurrency": "Vælg en",
      "selectBillingPeriod": "Vælg en",
      "billingPeriod": "Vælg faktureringsperiode"
    },
    "validations": {
      "validPrice": "Indtast en gyldig pris",
      "required": "Vælg et kursus",
      "validMembershipPrice": "Indtast en gyldig medlemspris",
      "validTrialDays": "Indtast gyldige dage i prøveversion",
      "requiredSubscriptionType": "Vælg abonnementstype",
      "courseVisibility": "Vælg kursus Synlighed",
      "requiredGamificationLevel": "Vælge Gamification Flad",
      "requiredPrivateChannel": "Vælg privat kanal",
      "validAccessStartDay": "Indtast gyldig Få adgang til start Dag"
    },
    "descriptions": {
      "buyNowDescription": "Dette kursus er tilgængeligt ved køb",
      "timeUnlockDescription": "Medlemmer låser op efter X dage",
      "levelUnlockDescription": "Kun medlemmer på et bestemt niveau vil kunne låse op",
      "allMembersDescription": "Alle medlemmer har adgang til dette kursus",
      "privateChannelDescription": "Medlemmer af en privat kanal",
      "privateDescription": "Adgang tildeles kun af admin"
    },
    "helperText": {
      "levelBased": "Niveaubaseret",
      "timeLimited": "tidsbegrænset",
      "privateBased": "Privat",
      "free": "Gratis",
      "levelAvailableAt": "Tilgængelig hos Flad 0{value}",
      "timeLimitedAfterJoining": "Offentlig {value} {day} Efter at have tilmeldt sig gruppen",
      "day": "Dag",
      "days": "dage",
      "purchaseToUnlockAccess": "Køb dette kursus for at låse op for Få adgang til",
      "privateCourse": "Privat kursus - Adgang tildeles kun af admin",
      "locked": "Dette kursus er låst",
      "unlockAtLevel": "Dette kursus vil låse op på Flad {level}",
      "unlockAfterDays": "Dette kursus låser op efter {days} {dayText}",
      "privateChannelBased": "Privat kanalbaseret",
      "externalAccess": "Anden gruppe/andet tilbud"
    },
    "manageAccess": {
      "manageCourses": "Administrer kurser",
      "revokeCourseAccess": "Administrer kurser",
      "grantCoursesAccess": "Tildel kurser",
      "removeAccess": "Fjern adgang",
      "grantAccess": "Tildel adgang",
      "grant": "Tildel",
      "clear": "Ryd",
      "selectAll": "Vælg alle",
      "revokeAccessConfirmTitle": "Fjern kursusadgang?",
      "revokeAccessConfirmMessage": "Er du sikker på, at du vil fjerne adgangen til \"{courseName}\" for {userName}?",
      "externalAccessTooltip": "Kan ikke fjernes: Brugeren har adgang fra en anden gruppe eller et andet tilbud",
      "cannotRevokeAutoAccess": "Kan ikke fjernes: Adgang tildeles automatisk baseret på kursusindstillinger (betalt, niveau, tid eller gratis)",
      "searchPlaceholder": "Søg efter kurser",
      "noCoursesFound": "Ingen kurser fundet",
      "noCoursesSelected": "Ingen kurser valgt endnu",
      "noCoursesAvailable": "Ingen kurser tilgængelige til tildeling",
      "noSearchResults": "Ingen søgeresultater",
      "failedToLoadCourses": "Kunne ikke indlæse kurser",
      "accessRevoked": "Kursusadgang er blevet fjernet",
      "failedToRevokeAccess": "Kunne ikke fjerne kursusadgang",
      "accessGranted": "Kursusadgang er blevet tildelt",
      "multipleAccessGranted": "{count} kurser er blevet tildelt",
      "failedToGrantAccess": "Kunne ikke tildele kursusadgang"
    },
    "ariaLabels": {
      "courseCard": "Kursusoversigt",
      "courseCardActions": "Kursusoversigthandlinger",
      "editCourse": "Rediger kursus",
      "deleteCourse": "Slet kursus",
      "moveCard": "Flyt oversigt",
      "copyLink": "Kopiér link",
      "cardImage": "Kursusoversigtsbillede"
    }
  },
  "about": {
    "notifications": {
      "errorUploadingFile": "Fejl ved upload af fil"
    },
    "uploadLinkVideo": "Upload/linkvideo",
    "removeMedia": "Slet medierne {fileName}"
  },
  "leaderboard": {
    "level": "Niveau",
    "lastUpdated": "Sidst opdateret",
    "members": "Medlemmer",
    "percentOfMembers": "{percentage} % af medlemmer",
    "rewards": "Belønninger",
    "allTime": "Altid",
    "pointsToLevelUp": "point for at komme op i niveau",
    "points": "Point",
    "leaderboard7d": "Rangliste (7 dage)",
    "leaderboard30d": "Rangliste (30 dage)",
    "leaderboardAlltime": "Rangliste (altid)",
    "yourRank": "Dit rang",
    "noActivityToShow": "Der er ingen aktivitet at vise",
    "rewardsWillBeDisplayedHere": "Belønninger vil blive vist her",
    "seeAllLeaderboards": "Se alle ranglister",
    "addRewards": "Tilføj belønninger",
    "howPointsWork": "Du optjener point, når andre medlemmer kan lide dine opslag eller kommentarer. 1 synes godt om = 1 point. Dette tilskynder brugerne til at producere kvalitetsindhold og interagere med andre medlemmer i deres fællesskab.",
    "levels": "Niveauer",
    "levelsDescription": "Efterhånden som du får point, stiger du i niveau. Dit niveau vises nederst til højre på din avatar. Antallet af point, der kræves for at komme til det næste niveau, vises via statuslinjen på siden Rangliste.",
    "pointsAndLevels": "Punkt og forsinkelse"
  },
  "events": {
    "createEvent": "Opret begivenhed",
    "dragAndDrop": "Træk og slip en SVG, PNG eller JPG (maks. 800 x 400 px)",
    "editEvent": "Rediger begivenhed",
    "addEvent": "Tilføj begivenhed",
    "paymentDetails": "Betalingsoplysninger",
    "event": "Begivenhed",
    "goBack": "Gå tilbage",
    "cancelEdit": "Annuller rediger",
    "cancelEvent": "Annuller begivenhed",
    "next": "Næste",
    "saveEvent": "Gem begivenhed",
    "editRecurringEvent": "Rediger tilbagevendende begivenhed",
    "thisEvent": "Denne begivenhed",
    "thisAndFollowingEvents": "Denne og følgende begivenheder",
    "ok": "OK",
    "deleteRecurringEvent": "Slet tilbagevendende begivenhed",
    "allEvents": "Alle arrangementer",
    "adminsFreeForPaidEvents": " * Administratorer kan tilmelde sig Betalt Begivenheder gratis",
    "deleteEvent": "Slet begivenhed",
    "onceEventDeleted": "Når begivenheden er slettet, vises den ikke i din kalender.",
    "toRegister": "at registrere",
    "calendar": "Kalender",
    "addToCalendar": "Tilføj til kalender",
    "declineRegistration": "Afvis",
    "paymentFailedMessage": "Din betaling mislykkedes på grund af nogle uforudsete omstændigheder. Prøv igen senere.",
    "upcoming": "Kommende",
    "noMoreEvents": "Der er ikke flere begivenheder at vise",
    "joinGroupToRegister": "Du skal være en del af denne gruppe for at tilmelde dig denne begivenhed",
    "past": "Forrige",
    "youHaveRegisteredForOneEvent": "Du har tilmeldt dig 1 begivenhed. Vi sender dig en påmindelse en dag før hver begivenhed.",
    "upcomingEvents": "Kommende begivenheder",
    "noUpcomingEvents": "Ingen kommende begivenheder",
    "pastEvents": "Forrige begivenheder",
    "noPastEvents": "Ingen tidligere begivenheder",
    "noMatchingEventFound": "Der blev ikke fundet nogen matchende begivenhed",
    "recordings": "Optagelser",
    "week": "Uge",
    "month": "Måned",
    "today": "I dag",
    "registrationConfirmed": "Tilmelding Bekræftet for {event}.",
    "eventDeletedOrRestricted": "Begivenheden er slettet eller privat",
    "eventDeleted": "Begivenheden er blevet slettet",
    "eventRestricted": "Du har ikke adgang til denne begivenhed",
    "validations": {
      "titleValidation": "Titlen er påkrævet",
      "colorValidation": "Farven er påkrævet",
      "startTimeValidation": "Starttidspunktet er påkrævet",
      "endTimeValidation": "Sluttidspunktet er påkrævet",
      "endTimeAfterStartTime": "Sluttidspunktet skal være efter starttidspunktet.",
      "startTimeMustBeInFuture": "Starttidspunktet skal ligge i fremtiden",
      "locationValidation": "Placering er påkrævet",
      "locationValidationMobile": "Placering er påkrævet",
      "locationUrlValidation": "Gyldig placerings-URL er nødvendig",
      "descriptionValidation": "Beskrivelse er påkrævet",
      "descriptionValidationMaxLength": "Beskrivelsen må ikke overstige 300 tegn",
      "recaptchaError": "Bekræftelse mislykkedes. Prøv igen",
      "repeatIntervalValidation": "Forekomst er påkrævet",
      "repeatIntervalValidator": "Intervallet for gentagelse skal være enten dag, uge, måned eller år",
      "repeatIntervalRequired": "Intervallet for gentagelse er påkrævet",
      "repeatOccurrenceValidator": "Gentagelsesforekomsten skal være større end 0",
      "repeatOccurrenceRequired": "Gentagelsesforekomsten er påkrævet",
      "invalidDateFormat": "Ugyldig datoformat",
      "endDateMustBeAfterStartDate": "Slutdatoen skal ligge efter begivenhedens startdato",
      "recurringEndDateValidation": "Tilbagevendende slutdato er påkrævet",
      "repeatsOnValidation": "Vælg mindst én dag",
      "invalidDaySelection": "Ugyldig valg af dag",
      "endOptionRequired": "Afslutningsmulighed er påkrævet",
      "levelValidation": "Vælg et niveau",
      "courseValidation": "Vælg et kursus",
      "channelValidation": "Vælg en kanal",
      "eventPriceValidation": "Pris er Påkrævet og skal være større end {min}"
    },
    "placeholders": {
      "selectStartTime": "Vælg starttidspunkt",
      "selectEndTime": "Vælg sluttidspunkt",
      "selectLocation": "Vælg placering",
      "locationUrl": "Link/adresse",
      "description": "Beskrivelse",
      "selectRecurringEndDate": "Vælg tilbagevendende slutdato",
      "selectDate": "Vælg dato",
      "event": "Begivenhed",
      "selectColor": "Vælg en farve",
      "selectAttendees": "Vælg deltagere",
      "selectPrivateChannel": "Vælg privat kanal",
      "selectCourse": "Vælg kursus",
      "selectLevels": "Vælg niveauer",
      "selectCalendar": "Vælg kalender"
    },
    "labels": {
      "startTime": "Starttid",
      "endTime": "Sluttid",
      "others": "Andre",
      "oneTimePriceForEventRegistration": "engangspris for eventtilmelding.",
      "totalAmount": "Beløb i alt",
      "cardAuthorizationText": "Ved at angive dine kortoplysninger giver du {locationName} mulighed for at debitere kort for fremtidige betalinger i overensstemmelse med deres vilkår.",
      "secureAndSafePayments": "100 % sikre betalinger",
      "day": "Dag",
      "week": "Uge",
      "month": "Måned",
      "year": "År",
      "recurringEvent": "Vil begivenheden være tilbagevendende begivenhed?",
      "repeatsEvery": "Gentages hver",
      "repeatsOn": "Gentages den",
      "end": "Slutter",
      "ends": "Slutning",
      "neverEnds": "Slutter aldrig",
      "orange": "Appelsin",
      "red": "Rød",
      "blue": "Blå",
      "green": "Grøn",
      "violet": "Violet",
      "purple": "Lilla",
      "yellow": "Gul",
      "title": "Titel",
      "color": "Farve",
      "allMembers": "Alle medlemmer",
      "membersAtALevel": "Medlemmer på et niveau",
      "membersOfACourse": "Medlemmer af et kursus",
      "membersOfAPrivateChannel": "Medlemmer af en privat kanal",
      "whoCanAttendTheEvent": "Hvem kan deltage i arrangementet?",
      "channel": "Kanal",
      "course": "Kursus",
      "level": "Niveau",
      "remindAttendeesByEmail": "Påmind deltagerne Via E-mail 1 Dag Før",
      "hideLocationFromNonAttendees": "Skjul placering fra ikke-deltagere.",
      "addChargesToTheEvent": "Tilføj gebyrer til begivenheden",
      "noPaymentRequired": "Der kræves ingen betaling",
      "location": "Placering",
      "link": "Link",
      "description": "Beskrivelse",
      "timezone": "Tidszone",
      "eventType": "Begivenhedstype",
      "eventTypeChangeWarning": "Dynamisk til Begivenhedstypen Eller prissætningen vil sendes til hvert tilfælde in serien.",
      "never": "Aldrig",
      "on": "Til",
      "after": "Efter",
      "occurrences": "tilfælde",
      "selectEventEnd": "Vælge Når den Begivenhed vil Slutning.",
      "turnOnTestPayments": "Vend Til Test Via et Test",
      "pay": "Betale",
      "hideAttendees": "Skjule deltagere Fra Gruppe Medlemmer",
      "guests": "{count} gæster",
      "guestList": "Gæst Liste",
      "noAttendees": "Ingen deltagere endnu",
      "viewAttendees": "Vis deltagere",
      "exportAttendees": "Eksportere deltagere"
    },
    "notifications": {
      "eventCreated": "Tildelt Oprettet!",
      "pickImageFailed": "Kunne ikke vælge billede",
      "pickImageFailedContent": "Der opstod en fejl under valget af billedet.",
      "eventUpdated": "Tildelt med succes Opdateret!",
      "eventCreationFailed": "Oprettelse af Begivenhed mislykkedes.",
      "eventUpdateFailed": "Opdatering af Begivenhed mislykkedes.",
      "EVENT_CREATE_INVALID_TIME_RANGE": "Starttidspunktet skal være før sluttidspunktet.",
      "EVENT_CREATE_PAST_TIME_NOT_ALLOWED": "Starttidspunktet skal ligge i fremtiden.",
      "EVENT_CREATE_DURATION_EXCEEDED": "Begivenhedens varighed overstiger den maksimalt tilladte grænse.",
      "EVENT_CREATE_FAILED": "Kan ikke oprette begivenheden. Prøv igen.",
      "EVENT_UPDATE_NOT_FOUND": "Begivenheden kunne ikke opdateres, da den ikke blev fundet.",
      "EVENT_UPDATE_UNAUTHORIZED": "Du har ikke tilladelse til at opdatere denne begivenhed.",
      "EVENT_UPDATE_INVALID_OPERATION": "Denne handling til opdatering af begivenhed er ikke tilladt.",
      "eventDeleted": "Begivenheden blev slettet.",
      "eventDeletionFailed": "Sletning af begivenhed mislykkedes.",
      "paymentFailed": "Betaling mislykkedes.",
      "registrationSuccessful": "Tilmelding lykkedes",
      "registrationFailed": "Tilmelding mislykkedes",
      "addToCalendarFailed": "Kunne ikke føje begivenheden til kalenderen",
      "locationDetailsCopied": "Placeringsoplysningerne blev kopieret til udklipsholderen",
      "registrationDeclined": "Tilmeldingen blev afvist.",
      "registrationDeclinedFailed": "Registrering afvisning mislykkedes!",
      "fetchAttendeesFailed": "Deltagerne kunne ikke indlæses",
      "emailCopied": "E-mail Kopieret til udklipsholder",
      "exportAttendeesFailed": "Det lykkedes ikke at eksportere deltagere"
    },
    "selectCalendar": "Vælg kalender",
    "eventImage": "Begivenhedsbillede",
    "errorLoadingEvent": "Der opstod en fejl under indlæsning af begivenhed"
  },
  "login": {
    "invite": "inviterede dig til at deltage"
  },
  "contentReports": {
    "contentDeleted": "Indholdet er blevet slettet.",
    "noActionTaken": "Ingen handling blev foretaget på det rapporterede indhold!",
    "reportedContentNotFound": "Det rapporterede indhold blev ikke fundet. Der er muligvis allerede reageret på det.",
    "reported": "Rapporteret",
    "viewAllReportedContentHere": "Du kan se alt det rapporterede indhold her",
    "takeActionOnReportedContent": "Reager på det rapporterede indhold",
    "andOthers": "og {count} andre",
    "reportedThisPost": "anmeldte dette indlæg",
    "keep": "BEHOLD",
    "remove": "FJERN",
    "deleteContent": "Slet indhold",
    "deleteConfirmation": "Er du sikker på, at du vil slette dette indhold?",
    "noMemberReportedContent": "Intet medlemsrapporteret indhold",
    "whenMembersReportPostsOrComments": "Når medlemmer rapporterer indlæg eller feedback, vises de her, så du kan gennemgå det. Du kan beholde eller slette det samt suspendere, fjerne eller blokere de medlemmer, der har slået dem op.",
    "reportedThisComment": "Du har anmeldt denne kommentar"
  },
  "contentUnavailable": {
    "thisContentIsntAvailable": "Dette indhold er ikke tilgængeligt i øjeblikket",
    "whenThisHappens": "Når dette sker, skyldes det normalt, at ejeren kun har delt det med en lille gruppe personer eller ændret, hvem der kan se det, eller at det er blevet slettet"
  },
  "search": {
    "noResultsFor": "0 resultater for \"{query}\" i fællesskabet",
    "noResultsFound": "Der blev ikke fundet nogen resultater"
  },
  "noCommunities": {
    "noCommunitiesFound": "Der blev ikke fundet nogen fællesskaber",
    "startCreatingYourOwnCommunities": "Start at skabe dine egne fællesskaber og interagere med dit publikum.",
    "noCommunitiesFoundGokollab": {
      "notJoinedA": "Ikke tilmeldt et",
      "communities": "Fællesskaber",
      "yet": "endnu"
    },
    "noCommunitiesFoundGokollabDescription": "Opdag rum, hvor mennesker deler ideer, støtter hinanden og vokser sammen."
  },
  "noCourses": {
    "noCoursesFoundGokollab": {
      "notEnrolledInA": "Ikke tilmeldt et",
      "course": "kursus",
      "yet": "endnu"
    },
    "noCoursesFoundGokollabDescription": "Udforsk kurser med stor effekt, der er designet til at hjælpe dig med at lære, forbedre dig og få succes."
  },
  "notFound": {
    "ohNo": "Åh nej ...",
    "weHaveHadAnError": "Der er opstået en fejl",
    "error404": "Fejl 404",
    "sorryPleaseCheckBack": "Beklager ... vend tilbage om et øjeblik."
  },
  "time": {
    "justNow": "Lige nu",
    "timeAgo": "{value} {unit} siden",
    "timeAgoFull": "{value}  {unit} siden",
    "units": {
      "year": "å",
      "years": "år",
      "month": "md",
      "months": "måneder",
      "week": "u",
      "weeks": "uger",
      "day": "d",
      "days": "dage",
      "hour": "t",
      "hours": "timer",
      "minute": "m",
      "minutes": "minutter",
      "second": "s",
      "seconds": "Søge",
      "monthly": "Månedlig",
      "weekly": "Ugentlig",
      "annually": "Årligt"
    },
    "dayAbbreviations": {
      "mon": "Man",
      "tue": "Tirs",
      "wed": "Ons",
      "thu": "Tors",
      "fri": "Fre",
      "sat": "Lør",
      "sun": "Søn"
    }
  },
  "emojiPicker": {
    "notfound": "Der blev ikke fundet nogen emoji",
    "recent": "Ofte brugt",
    "smileys": "Smileys og humørikoner",
    "people": "Mennesker og Indhold",
    "nature": "Dyr og natur",
    "foods": "Mad og drikke",
    "activity": "Aktivitet",
    "places": "Rejser & Pladser",
    "objects": "Objekter",
    "symbols": "Underskriv",
    "flags": "Flag",
    "custom": "Tilpasset"
  },
  "topNavBarHeaderText": {
    "discussion": "Opslag",
    "learning": "læring",
    "people": "Mennesker"
  },
  "globalUserProfile": {
    "ownedBy": "Ejet af {name}",
    "memberships": "Medlemskaber",
    "membershipsInCommon": "Medlemskaber ({count} til fælles)",
    "membersCount": "{count} medlemmer",
    "contributions": "{count} bidrag til {group}",
    "contributionsFor": "Bidrag til",
    "justPosts": "Kun indlæg",
    "postAndComments": "Indlæg og kommentarer",
    "followSuccess": "Du er begyndt at følge",
    "unfollowSuccess": "Du følger ikke længere"
  },
  "profile": {
    "active": "Aktiv",
    "ago": "siden",
    "bio": "Biografi"
  },
  "golive": {
    "golive": "Gå live",
    "liveRoom": "Live-room",
    "defaultEventTitle": "Live-begivenhed i fællesskabet",
    "meetingCreationFailed": "Kunne ikke oprette GoLive-møde. Prøv igen.",
    "selectVideoSourceToStart": "Vælg en videokilde for at starte streaming",
    "chooseHowToGoLive": "Vælg, hvordan du vil gå live",
    "flipCamera": "Vend kameraet",
    "participants": "Medlemmer",
    "chats": "Chats",
    "react": "Reager",
    "raise": "Hæv",
    "shareScreen": "Del",
    "letsCheckYourCamAndMic": "Lad os tjekke dit kamera og din mikrofon",
    "hostedBy": "Arrangeres af",
    "join": "Deltag",
    "needCameraPermission": "Kræver kameratilladelse",
    "needMicrophonePermission": "Kræver mikrofontilladelse",
    "needSpeakerPermission": "Kræver højttalertilladelse",
    "createLiveVideo": "Opret en livevideo",
    "host": "Vært",
    "chooseWhereToPost": "Vælg, hvor du vil slå op",
    "whenAreYouGoingLive": "Hvornår går du live?",
    "postingIn": "indlæg i",
    "live": "Live",
    "postDetails": "Indlægsoplysninger",
    "streamingSoftware": "Streamingsoftware",
    "streamingSoftwareDescription": "Du kan bruge streamingsoftware som Zoom, OBS eller StreamYard til at sende direkte. Du skal blot kopiere den angivne stream-URL og stream-nøgle ind i indstillingerne for din streamingsoftware. Når den er konfigureret, skal du starte din udsendelse i softwaren, og den vil automatisk streame live til din valgte platform.",
    "streamKey": "Streamnøgle",
    "streamKeyDescription": "Dette kan genbruges, hver gang du går live. Du kan kun udsende én livevideo ad gangen med din permanente streamingnøgle.",
    "serverUrl": "Server-URL",
    "serverUrlDescription": "Dette kan muligvis kaldes \"URL\" eller \"Adresse\" i din streamingsoftware.",
    "selectVideoSource": "Vælg videokilde",
    "copyPasteStreamKey": "Kopiér og indsæt streamnøglen i din streamingsoftware.",
    "copyPasteServerUrl": "Kopier og indsæt server-URL'en i din streamingsoftware.",
    "addPostDetails": "Tilføj opslagsdetaljer",
    "enterTitle": "Indtast din titel",
    "notifyMembers": "Giv medlemmer besked om, at du går live (sender kun notifikationer i appen og push-notifikationer)",
    "notifyMembersMobile": "Giv medlemmerne besked om, at du går live",
    "meetingRoom": "Mødelokale",
    "meetingRoomDescription": "Brug funktionen Møderum til at afholde livesessioner, hvor alle deltagere kan tænde deres webkameraer, slå lyden til og interagere i realtid. Dette skaber en virtuel rumoplevelse svarende til Zoom eller Google Meet, hvor alle kan se og tale med hinanden ansigt til ansigt.",
    "cameraControls": "Kamerakontrol",
    "cameraControlsTooltip": "Konfigurer dine kamera- og lydindstillinger, inden du går live. Sørg for, at dit kamera og din mikrofon er korrekt tilsluttet og har de nødvendige tilladelser.",
    "selectMediaSource": "Vælg en mediekilde",
    "startScreenShare": "Start skærmdeling",
    "stopScreenShare": "Stop skærmdeling",
    "wasLive": "var live",
    "isLive": "er live",
    "goingLive": "går live",
    "tapToAddDescription": "Tryk for at tilføje en beskrivelse ...",
    "selectChannel": "Vælg kanal",
    "saveAsPost": "Behold livestream som et opslag",
    "selectVideoSourceTooltip": "Du kan vælge mellem streamingsoftware eller webcam, når du går live:\n\n 1. Streamingsoftware\n • Vi giver dig en streamnøgle og en stream-URL.\n   • Du skal konfigurere disse i Zoom, OBS eller enhver tredjepartssoftware, der understøtter livestreaming.\n\n2. Webkamera\n • Gå direkte live med dit kamera og din mikrofon.\n   • Deltagerne kan se livestreamen og interagere via livechatten.\n   • Som vært kan du til enhver tid kontrollere og tilbagekalde adgang til kameraet eller mikrofonen.",
    "pleaseSelectCameraMicrophoneSpeaker": "Vælg kamera, mikrofon og højttaler",
    "pleaseStartStreamBeforeGoingLive": "Start streamen, før du går live",
    "watching": "Overvågning",
    "processingRecording": "Behandler optagelse",
    "recordingFailed": "Optagelse ikke tilgængelig",
    "recordingFailedDescription": "Vi stødte på et problem under behandlingen af denne live-session, og optagelsen kunne ikke gemmes",
    "streamEndedRecordingWillBeAvailableSoon": "Streaming sluttede. Optagelsen er under behandling og vil være tilgængelig snart.",
    "joinStream": "Deltag i streaming",
    "recordingInProgress": "Optagelse i gang",
    "recordingNotAvailable": "Optagelse mislykkedes",
    "leaveSession": "Forlad sessionen",
    "endSession": "Afslut sessionen",
    "rec": "REC",
    "selectCamera": "Vælg kamera",
    "noCamerasFound": "Der blev ikke fundet nogen kameraer",
    "cameraPermissionNeeded": "Kameratilladelse påkrævet",
    "leave": "Forlad",
    "chooseMicCam": "Vælg mikrofon/kamera",
    "selectMicrophone": "Klik på mikrofonen",
    "selectSpeaker": "Vælg højttaler",
    "noMicrophonesFound": "Der blev ikke fundet nogen mikrofoner",
    "noSpeakersFound": "Der blev ikke fundet nogen højttalere",
    "microphonePermissionNeeded": "Kræver mikrofontilladelse",
    "speakerPermissionNeeded": "Kræver højttalertilladelse",
    "noParticipantOpenCamOrMic": "Dette møde blev ikke optaget, da ingen deltagere havde aktiveret deres mikrofon eller kamera. Optagelser oprettes kun, når mindst én deltager interagerer."
  }
}
